import {
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

export default ChowbusDialog;

const useDialogStyles = makeStyles({
  paper: {
    borderRadius: 13,
  },
  content: {
    marginBottom: 10,
  },
});

function ChowbusDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useDialogStyles();
  return (
    <Dialog
      open={props.isDialogOpen}
      onClose={props.onCloseDialog}
      fullScreen={fullScreen}
      maxWidth='xs'
      fullWidth
      classes={{
        paper: classes.paper,
        paperFullWidth: classes.paper,
      }}>
      <ChowbusDialogTitle onClose={props.onCloseDialog}>{props.title}</ChowbusDialogTitle>
      <DialogContent
        classes={{
          root: classes.content,
        }}>
        {props.children}
      </DialogContent>
    </Dialog>
  );
}

const useTitleStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

function ChowbusDialogTitle(props) {
  const classes = useTitleStyles();
  return (
    <DialogTitle disableTypography className={classes.root}>
      <Typography variant='h6'>{props.children}</Typography>
      {props.onClose ? (
        <IconButton aria-label='close' className={classes.closeButton} onClick={props.onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}
